import { observer } from "mobx-react";
import { useEstimateStructure, useVisibilityModeCellClassName, ValueCell } from "@tools";

export const TeamMembersCell = observer((cellProps) => {
  const structure = useEstimateStructure();
  const { hideSummaryTeam } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryTeam);
  
  return <ValueCell size="medium" className={className} { ...cellProps} />;
})